import { createUseStyles } from 'react-jss'
import { black, neonLime, neonLimeLight, neonLimeDark, white } from '../../../styles/colors'

const useStyles = createUseStyles(() => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    padding: '13px 22px',
    boxSizing: 'border-box',
    borderRadius: '9999px',
    fontSize: '16px',
    lineHeight: '100%',
    textTransform: 'uppercase',
    fontFamily: 'GothamRounded',
    fontWeight: 500,
    cursor: 'pointer',
    height: '48px'
  },

  link: {
    color: 'black !important',
    textDecoration: 'none'
  },

  primaryButton: {
    backgroundColor: neonLime,

    '&:hover': {
      backgroundColor: neonLimeLight
    },
    '&:active': {
      backgroundColor: neonLimeDark
    }
  },

  secondaryButton: {
    color: white,
    opacity: 1,
    backgroundColor: '#5B5B5B33',
    border: '1.25px solid transparent',
    backgroundImage: `linear-gradient(#232323, #232323),
    linear-gradient(156.52deg, rgba(255, 255, 255, 0.2) 2.12%, rgba(255, 255, 255, 0.0001) 39%, rgba(255, 255, 255, 0.0001) 54.33%, rgba(255, 255, 255, 0.05) 93.02%)`,
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',

    "& a": {
      color: '#ffffff !important',
      textDecoration: 'none'
    },

    "&:hover": {
      background:
        `linear-gradient(0deg, var(--colours-translucent-grey-med-20, rgba(51, 51, 51, 0.6)), var(--colours-translucent-grey-med-20, rgba(51, 51, 51, 0.6))),
        radial-gradient(44.98% 63.54% at 50% -5.21%, rgba(255, 255, 255, 0.14) 0%, rgba(69, 69, 69, 0) 100%)`
    }
  },

  '@global': {
    div: {
      '&$primaryButton > a': {
        color: black,
        textDecoration: 'none'
      }
    }
  }
}))

export default useStyles
